import { useEffect, useState } from 'react'
import Modal from 'react-modal'
import { fetchHelpTopics, downloadHelpTopicApi } from 'infra/services/help-topics'
import { useHistory } from 'react-router-dom'
import { HelpPageCurrentStyle } from './styles'
import { translate } from '../../../../../i18n'
import { Cancel, PlayCircleFilled } from '@mui/icons-material'
import Loading from 'presentation/components/ui/loading/loading';

const HelpPageCurrent = (props) => {
  const history = useHistory()
  const [valuesToHelpTopics, setValuesToHelpTopics] = useState<any>([])
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [imageSrc, setImageSrc] = useState(null);
  const [fileSrc, setFileSrc] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const { data } = await fetchHelpTopics({
          enabled: 1,
          appWebPath: !stringContainsNumber(history.location.pathname).trim() ? 'home-ubere' : stringContainsNumber(history.location.pathname)
        })
        const objHelp = data['hydra:member'];
        setValuesToHelpTopics(data['hydra:member'])
        let imageUrl = null
        let fileUrl = null

        if (objHelp[objHelp.length - 1]?.cover) {
          const url = objHelp[objHelp.length - 1]?.cover?.pathApi;
          const path = url.substring(url.indexOf("/download"));
          const response = await downloadHelpTopicApi(path)
          imageUrl = URL.createObjectURL(response.data)
          setImageSrc(imageUrl);
        };

        if (objHelp[objHelp.length - 1]?.file) {
          const url = objHelp[objHelp.length - 1]?.file?.pathApi;
          const path = url.substring(url.indexOf("/download"));
          const response = await downloadHelpTopicApi(path)
          fileUrl = URL.createObjectURL(response.data)
          setFileSrc(fileUrl);
          setIsLoading(false);
        };
      } catch (error) {
        console.log("🚀 ~ file: video.tsx:48 ~ error:", error)
        setIsLoading(false);
      };
    })()
  }, [history.location.pathname])

  function openModal() {
    setModalIsOpen(true)
  }

  function closeModal() {
    setModalIsOpen(false)
  }

  function stringContainsNumber(string: string) {
    const containNumber = /\d/.test(string)

    if (containNumber) {
      history.location.pathname = history.location.pathname.replace(/[0-9]/g, '') + ':id'
    }

    return history.location.pathname.replace('/', '')
  }

  return (
    <HelpPageCurrentStyle style={{ ...props.style }} >
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        overlayClassName="react-modal-overlay"
        className="react-modal-content-help-section"
      >
        <div onClick={closeModal} className="react-modal-header">
          <h3 >{translate('labelFechar')}</h3>
          <Cancel style={{ color: '#FFF', fontSize: 20 }} />
        </div>
        <div className="react-modal-help-content">
          <h2>{valuesToHelpTopics[valuesToHelpTopics.length - 1]?.title}</h2>
          {valuesToHelpTopics[valuesToHelpTopics.length - 1]?.type === 'video'
            ? (
              isLoading
                ? (
                  <Loading />
                )
                : (
                  <video width="705" height="398" controls={true} autoPlay={false}>
                    <source src={fileSrc} type="video/mp4" />
                    O seu navegador não suporta a tag vídeo
                  </video>
                )
            )
            : (
              <>
                <div className="react-modal-help-content-img">
                  <img className="img-pdf" src={imageSrc} alt="" />
                </div>
                <div className="react-modal-help-viewer-button">
                  <button>
                    <a target="__blank" href={fileSrc}>VISUALIZAR ARQUIVO</a>
                  </button>
                </div>
              </>
            )
          }
        </div>
      </Modal>

      <div onClick={openModal} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <PlayCircleFilled style={{ color: '#8C2458', fontSize: 20, margin: 'auto' }} />
        <span className='labelAjuda'>{translate('labelAjuda')}</span>
      </div>
    </HelpPageCurrentStyle>
  )
}

export default HelpPageCurrent
